import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["id"]

import {
    ref,
    toRefs,
    computed,
} from 'vue'
import { useFocus } from '@vueuse/core';
import { QInput } from 'quasar';

// Personal libs
import { $t } from 'src/i18n/utils';
import {
    messageRules
} from '@shared/lib/form.lib';

/**
 * HTMLElement refs
 */
interface QInputEmailProps {
    // Model
    modelValue?: string

    // Content
    label: string
    placeholder?: string
    ariaDescribedBy?: string
    showAriaDescription?: boolean
    minimumLength?: number

    // Style
    extraClass?: string;
    dense?: boolean

    // State
    disable?: boolean
    required?: boolean
   
    // Actions
    onEnterKey?: (...args: any[]) => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'QInputMessage',
  props: {
    modelValue: {},
    label: {},
    placeholder: { default: undefined },
    ariaDescribedBy: {},
    showAriaDescription: { type: Boolean, default: false },
    minimumLength: { default: 6 },
    extraClass: {},
    dense: { type: Boolean, default: false },
    disable: { type: Boolean, default: false },
    required: { type: Boolean, default: true },
    onEnterKey: { type: Function, default: undefined }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

// Vendor
const customQInputTextarea = ref<QInput>();
const { focused: customQInputTextareaFocused } = useFocus(customQInputTextarea);

/**
 * Properties
 */
const props = __props;
const {
    onEnterKey,
    required,
    label,
    placeholder,
    ariaDescribedBy,
    extraClass,
    disable,
    dense,
    modelValue
} = toRefs(props);

/**
 * Events
 */
const emit = __emit

/**
 * Computed properties
 */
// If required, add a star at the beginning of the label
const computedLabel = computed<string>(() => `${required.value ? '* ' : ''}${label.value}`)

/**
 * Methods
 */
function clearTextarea() {
    customQInputTextarea.value?.resetValidation();
    emit('update:modelValue', undefined)
    customQInputTextareaFocused.value = true;
}

function hasError() {
    return customQInputTextarea.value?.hasError
}

function validate() {
    customQInputTextarea.value?.validate()
}

function resetValidation() {
    customQInputTextarea.value?.resetValidation()
}

/**
 * Exposed methods
 */
__expose({
    clearTextarea,
    hasError,
    validate,
    resetValidation
})

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(ariaDescribedBy) == null)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass({
                'q-mx-sm': true,
                'sr-only': _ctx.showAriaDescription === false
            }),
          id: _unref(ariaDescribedBy) ?? 'id_example_textarea'
        }, " Texte contenant au moins " + _toDisplayString(_ctx.minimumLength ?? 6) + " caractères. ", 11 /* TEXT, CLASS, PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    _createVNode(_unref(QInput), {
      "model-value": _unref(modelValue),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = (newValue) => emit('update:modelValue', newValue)),
      ref_key: "customQInputTextarea",
      ref: customQInputTextarea,
      dense: _unref(dense),
      placeholder: _unref(placeholder),
      "aria-required": _unref(required),
      "aria-describedby": _unref(ariaDescribedBy) ?? 'id_example_textarea',
      "aria-invalid": 
                !_unref(modelValue) || (_unref(modelValue) && _unref(modelValue).length < 6)
                    ? 'true'
                    : 'false'
            ,
      "aria-disable": _unref(disable),
      disable: _unref(disable),
      label: computedLabel.value,
      type: "textarea",
      outlined: "",
      autocomplete: "current-password",
      rows: "3",
      "max-rows": "6",
      "bg-color": _ctx.$q.dark.isActive ? 'black' : 'white',
      "label-color": _ctx.$q.dark.isActive ? 'white' : 'black',
      class: _normalizeClass(['q-mb-sm', _unref(extraClass)]),
      "input-class": [
                _ctx.$q.dark.isActive ? 'text-white' : 'text-black',
                'set-outline',
            ],
      "hide-bottom-space": "",
      "lazy-rules": "",
      rules: _unref(messageRules),
      enterkeyhint: "done",
      onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_unref(onEnterKey) != null ? _unref(onEnterKey)() : undefined), ["enter"]))
    }, {
      append: _withCtx(() => [
        _createVNode(_component_q_btn, {
          flat: "",
          round: "",
          dense: "",
          icon: "cancel",
          class: "set-outline",
          color: "primary",
          title: _unref($t)('form.message.reset'),
          disable: _unref(disable),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (clearTextarea()), ["stop"]))
        }, null, 8 /* PROPS */, ["title", "disable"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model-value", "dense", "placeholder", "aria-required", "aria-describedby", "aria-invalid", "aria-disable", "disable", "label", "bg-color", "label-color", "class", "input-class", "rules"])
  ]))
}
}

})